import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Reveal";
import { FAQ_GROUPS } from "@/lib/data";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="bg-bone py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="max-w-3xl mb-16">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-clay">
            <span className="h-[1px] w-10 bg-clay" /> Questions &amp; answers
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-[var(--astera-char)]">
            Frequently asked <span className="italic text-clay">questions.</span>
          </h2>
          <p className="mt-6 text-[var(--astera-char)]/65 leading-relaxed">
            Clear answers. Personalized care. No question is too small when it comes to your health.
          </p>
        </Reveal>
      </div>

      <div className="space-y-14">
        {FAQ_GROUPS.map((group, gi) => (
          <div key={group.category} className="grid lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-4">
              <Reveal>
                <h3 className="font-serif text-2xl md:text-3xl text-[var(--astera-char)] lg:sticky lg:top-28">
                  {group.category}
                </h3>
              </Reveal>
            </div>
            <div className="lg:col-span-8">
              <Reveal delay={0.05}>
                <Accordion type="single" collapsible className="w-full">
                  {group.items.map((item, i) => (
                    <AccordionItem
                      key={i}
                      value={`g${gi}-i${i}`}
                      data-testid={`faq-item-${gi}-${i}`}
                      className="border-[#EAE6E1]"
                    >
                      <AccordionTrigger className="py-6 font-serif text-lg md:text-xl text-[var(--astera-char)] hover:no-underline hover:text-clay [&>svg]:text-clay [&>svg]:h-5 [&>svg]:w-5">
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="pb-7">
                        <div className="space-y-4 max-w-2xl">
                          {item.a.map((p, k) => (
                            <p
                              key={k}
                              className="text-[var(--astera-char)]/70 leading-relaxed text-[0.95rem]"
                            >
                              {p}
                            </p>
                          ))}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Reveal>
            </div>
          </div>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-16 text-xs text-[var(--astera-char)]/45 max-w-3xl">
          The information here is general and does not replace personalized medical advice. Your
          care, options and any risks are discussed individually with Dr. Fefelova.
        </p>
      </Reveal>
    </div>
  </section>
);
